import { Pipe, PipeTransform } from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Pipe({
  name: 'pills'
})
export class PillsPipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer) { }

    transform(value: any, args?: any): any {
      let str = '';
      if (value && value.length > 0) {
          value.forEach(function (pill) {
              str += '<button type="button" class="btn btn-sm btn-pill btn-primary" disabled="disabled">' + pill + '</button> '
          })
      }

      return this.sanitizer.bypassSecurityTrustHtml(str);
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/pipes/pills.pipe.ts